module.exports = __webpack_public_path__ + "img/shipo-icon-calendar-expired.ccba5989.svg";